export default __webpack_public_path__ + "static/media/bio.a8e7f850.jpg";